// extracted by mini-css-extract-plugin
export default {"link":"DM-z","disabled":"EM-z"};